import React from "react"
import loadingGif from "../../assets/images/loading.gif"

const Loader = props => {
  return (<div className="loading-spinner ">
    <img className="" src={loadingGif} />
  </div>

  )
}


export default Loader
